<template>
    <div>
        <div class="cons">
            <div class="bread">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item style="cursor: pointer;" @click.native="handleBack">学历提升</el-breadcrumb-item>
                    <el-breadcrumb-item>{{info.name}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="acTivitiesDetail">
                <div class="flx">
                    <div class="acImg">
                        <img :src="$img(info.pc_avatar)" alt="" />
                    </div>
                    <div class="acInfo">
                        <div class="acNames flx jsb">
                            <div class="acName" v-text="info.name"></div>
                        </div>

                        <div class="labels flx alc">
                            <div class="label" v-text="info.label"></div>
                            <div class="label" v-text="info.city_name"></div>
                        </div>

                        <div class="lades single" v-text="info.intro">

                        </div>
                        <div class="btnLeft cursor" @click="suborder">
                            马上咨询
                        </div>
                    </div>
                </div>
            </div>
            <div class="actips flx jsb">
                <div class="tipLeft">
                    <div class="acintro">
                        <div class="courseDes">
                            <div class="actitles">
                                <div class="actName">
                                    课程介绍
                                </div>
                                <div class="bheng"></div>
                            </div>
                            <div class="acD" v-html="info.content">

                            </div>
                        </div>

                    </div>
                </div>
                <div class="tipRight">
                    <div class="bottomPart">
                        <div class="bpt">
                            推荐课程
                        </div>
                        <div class="reItem cursor" :style="index == 2?'border:none;margin-bottom:0' : ''"
                            v-for="item,index in info.recomm_e_list" @click="toDetail(item)">
                            <div class="reImg">
                                <img :src="$img(item.pc_avatar)" alt="" />
                            </div>
                            <div class="reInfo">
                                <div class="reName multy2" v-text="item.name"></div>
                                <div class="readdress" v-text="item.label"></div>
                                <div class="reTitle single" v-text="item.title"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 确认订单弹窗 -->

            <el-dialog title="自定义弹窗标题" :visible.sync="dialogVisible" width="638px">
                <span slot="title">
                    <span style="font-size: 16px;color: #1a1a1a;font-weight: 600;">确认订单</span>
                </span>
                <!-- 这里是完全自定义区域，想写什么写什么 -->
                <div class="custom-dialog-content">
                    <div class="part">
                        <div class="ordernames flx alc">
                            <div class="orderName" v-text="info.name"></div>
                            <div class="orderPrice" v-text="`￥${info.default_price}`"></div>
                        </div>
                        <div class="orderDes" v-text="info.time2">

                        </div>
                    </div>

                    <div class="part">
                        <div class="orderTitle">
                            付款信息
                        </div>
                        <div class="goodsPrice flx jsb">
                            <div class="gpname">
                                商品金额
                            </div>
                            <div class="orderPrice" v-text="`￥${info.default_price}`"></div>
                        </div>
                        <div class="totalPrice flx">
                            合计: <span style="color: #EF4444;font-size: 16px;" v-text="`￥${info.default_price}`"></span>
                        </div>
                    </div>
                    <div class="part">
                        <div class="orderTitle">
                            选择支付方式
                        </div>
                        <div class="pays flx jsb ">
                            <div class="payItem flx alc">
                                <el-radio v-model="paymethod" label="1">支付宝</el-radio>
                            </div>
                            <div class="payItem flx alc">
                                <el-radio v-model="paymethod" label="2">微信</el-radio>
                            </div>
                        </div>
                    </div>
                    <div class="subbtn cursor" @click="suborder">
                        马上支付
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {
        getEduDetail
    } from "@/api/index.js"
    import asideAc from "@/components/asidAc.vue"
    export default {
        components: {
            asideAc
        },
        data() {
            return {
                paymethod: "",
                dialogVisible: false,
                num: 1,
                cateName: '',
                id: '',
                page: 1,
                bannerList: [],
                recommand: [],
                totals: 0,
                info: {},
                rules: "",
                ticketId: "",
                channel_id: ''
            }
        },
        created() {
            this.id = this.$route.query.id
            this.getDetail()
        },
        watch: {
            $route: {
                handler(to, from) {
                    this.id = to.query.id
                    this.getDetail()
                },
                deep: true
            }
        },
        methods: {
            toDetail(e) {
                let that = this
                this.$router.push({
                    path: '/eduDetail', // 写路由path
                    query: {
                        id: e.id
                    }
                })
            },
            handleBack() {
                if (window.history.length > 1) {
                    this.$router.back()
                } else {
                    this.$router.push('/')
                }
            },
            suborder() {
                let that = this
                ysf('product', {
                    show: 1, // 1为打开， 其他参数为隐藏（包括非零元素）
                    // title: '订单号:' + that.info.order_no,
                    picture: that.$img(that.info.avatar),
                    note: '商品名称:' + that.info.name,
                    url: '跳转链接',
                    success: function() { // 成功回调
                        ysf('open');
                    },
                    error: function(err) { // 错误回调
                        // handle error
                    }
                })
            },
            selTicket(e, money) {
                this.ticketId = e
                this.info.default_price = money
            },
            focusThis() {
                let that = this
                let data = {}
                data.company_id = that.info.company_id
                focusCom(data).then((res) => {
                    if (res.code == 1) {
                        that.$message.success(res.msg)
                        that.getDetail()
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            colThis() {
                let that = this
                let data = {}
                data.id = that.id
                collectAcs(data).then((res) => {
                    if (res.code == 1) {
                        that.$message.success(res.msg)
                        that.getDetail()
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            getDetail() {
                let that = this
                let data = that.id
                getEduDetail(data).then((res) => {
                    console.log("res", res)
                    if (res.code == 1) {
                        that.info = res.data
                        that.$nextTick(() => {
                            window.scrollTo(0, 0)
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .custom-dialog-content {
        text-align: left;
    }

    .subbtn {
        width: 100%;
        height: 48px;
        background: linear-gradient(90deg, #4096FF 0%, #1677FF 100%);
        border-radius: 10px;
        text-align: center;
        line-height: 48px;
        font-weight: 600;
        font-size: 14px;
        color: #FFFFFF;
    }

    .payItem {
        width: 255px;
        height: 72px;
        border-radius: 10px;
        border: 1px solid #EEEEEE;
        box-sizing: border-box;
        padding: 0 18px;
        margin-top: 18px;
    }

    .totalPrice {
        justify-content: flex-end;
        color: #000;
        font-size: 16px
    }

    .goodsPrice {
        padding: 20px 0;
        border-bottom: 1px solid #f6f6f6;
    }

    .orderTitle {
        font-size: 18px;
        color: #000000;
    }

    .orderDes {
        font-size: 12px;
        color: #919296;
        margin-top: 12px;
    }

    .orderName {
        font-weight: 600;
        font-size: 16px;
        color: #000000;
        width: 80%;
    }

    .orderPrice {
        font-weight: 600;
        flex: 1;
        font-size: 16px;
        color: #000000;
        text-align: right !important;
    }

    .part {
        width: 100%;
        background: #fff;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 20px 16px;
        margin-bottom: 16px;
    }

    /* vue2 使用 /deep/ 穿透 scoped */
    /deep/ .el-dialog {
        border-radius: 10px;
        /* 整体圆角大小，自行调整 6px/8px/12px/16px */
        overflow: hidden;
        /* 关键：内部内容不会溢出圆角 */
        background: #F3F5F9;
    }

    .reTitle {
        font-size: 14px;
        color: #919296;
    }

    .readdress {
        font-size: 12px;
        color: #007AFF;
        line-height: 19px;
        box-sizing: border-box;
        padding: 0 5px;
        background: #F4F9FF;
        display: inline-block;
        margin-bottom: 10px;

    }

    .reName {
        font-weight: 600;
        font-size: 16px;
        margin-bottom: 14px;
    }

    .reItem {
        width: 100%;
        border-bottom: 1px solid #ececec;
        margin-bottom: 20px;
    }

    .reInfo {
        text-align: left;
        box-sizing: border-box;
        padding: 12px 0 20px;
    }

    .reImg {
        width: 292px;
        height: 164px;
        overflow-y:hidden
    }

    .reImg img {
        width: 100%;
        /* height: 100%; */
        border-radius: 6px;
    }

    .bpt {
        font-weight: 600;
        font-size: 24px;
        margin-bottom: 20px;
        text-align: left;
    }

    .bottomPart {
        background: #ffffff;
        width: 332px;
        box-sizing: border-box;
        padding: 20px;
    }

    .price1 {
        font-weight: 500;
        font-size: 24px;
        color: #EC1414;
        margin-right: 12px;
    }

    .price2 {
        font-size: 18px;
        color: #B1B5B9;
        text-decoration-line: line-through;
        text-transform: none;
    }

    .infname {
        font-weight: 500;
        font-size: 14px;
        color: #888B93;
        margin-right: 14px;
        line-height: 42px;
        width: 56px;
    }

    .acD /deep/ img {
        width: 100%;
        height: auto;
    }

    .lades {
        width: 900px;
        font-size: 14px;
        color: #919296;
        margin-bottom: 24px;
        text-align: left;
    }

    .labels {
        margin-bottom: 14px;
    }

    .label {
        height: 19px;
        box-sizing: border-box;
        padding: 0 5px;
        font-size: 12px;
        color: #007AFF;
        background: #F4F9FF;
        border-radius: 1px 1px 1px 1px;
        line-height: 19px;
        margin-right: 8px;
    }

    .tickets {
        flex-wrap: wrap;
        width: 500px;
    }

    .ticketPrice {
        font-weight: 500;
        font-size: 16px;
        color: #FF0F23;
        margin-right: 6px;
    }

    .ticketName {
        font-size: 12px;
        color: #666666;
    }

    .ticketItem img {
        position: absolute;
        right: 0;
        bottom: 0;
        margin-right: 0 !important;
    }

    .ticketItem {
        margin-bottom: 20px;
        height: 42px;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #D9D9D9;
        box-sizing: border-box;
        padding: 10px 20px;
        margin-right: 14px;
        position: relative;
        flex-shrink: 0;
    }

    .comDes {
        font-size: 14px;
        color: #6D6D6D;
        margin-top: 12px;
    }

    .acfocus {
        width: 68px;
        height: 38px;
        border-radius: 19px;
        border: 1px solid rgba(64, 150, 255, 1);
        text-align: center;
        line-height: 38px;
        font-size: 15px;
        color: #007AFF;
        font-weight: 500;
    }

    .unfocus {
        width: 68px;
        height: 38px;
        border-radius: 19px;
        color: #fff;
        text-align: center;
        line-height: 38px;
        font-size: 15px;
        background: #007AFF;
        font-weight: 500;
    }

    .cominfo {
        flex: 1;
    }

    .cominfo img {
        width: 14px;
        height: 14px;
    }

    .comTitle {
        font-weight: 600;
        font-size: 18px;
        margin-bottom: 8px;
    }

    .comImg {
        width: 60px;
        height: 60px;
        margin-right: 12px;
    }

    .comImg img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        margin-right: 12px;
        object-fit: cover;
    }

    .compart {
        width: 100%;
        background: #F7F8F9;
        border-radius: 6px;
        box-sizing: border-box;
        padding: 20px;

    }

    .bheng {
        width: 24px;
        height: 4px;
        background: #007AFF;
        margin: 0 auto;
        margin-top: 8px;
    }

    .actitles {
        display: inline-block;
        position: relative;
        margin-bottom: 20px;
    }

    .actName {
        font-weight: 500;
        font-size: 18px;
        color: #3C464F;

    }

    .acintro {
        background-color: #fff;
        box-sizing: border-box;
        padding: 26px;
        text-align: left;
    }

    .tipLeft {
        width: 1106px;

    }

    .buytip {
        text-align: left;
        width: 100%;
        background: #fff;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 26px;
    }

    .actips {
        margin-top: 16px;
    }

    .btns {
        margin-top: 26px;
        box-sizing: border-box;
        padding-left: 433px;
    }

    .btnRight i {
        margin-right: 6px;
    }

    .btnRight {
        width: 130px;
        height: 40px;
        border-radius: 8px;
        border: 1px solid rgba(64, 150, 255, 1);
        justify-content: center;
        font-weight: 600;
        font-size: 14px;
        color: #007AFF;
    }

    .btnLeft {
        width: 280px;
        height: 40px;
        background: linear-gradient(90deg, #4096FF 0%, #1677FF 100%);
        border-radius: 20px;
        text-align: center;
        line-height: 40px;
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
    }

    .freePart {
        width: 48px;
        height: 26px;
        background: #EFF6FF;
        border-radius: 13px;
        font-size: 12px;
        color: #1E40AF;
        text-align: center;
        line-height: 26px;
    }

    .acNames {
        margin-bottom: 22px;
    }

    .infItem span {
        font-size: 14px;
        color: #1F2937;
    }

    .infItem {
        margin-bottom: 16px;
    }

    .infItem img {
        width: 20px;
        height: 20px;
        margin-right: 12px;
    }

    .buyItem {
        font-size: 14px;
        margin-left: 18px;
    }

    .buyItem img {
        width: 20px;
        height: 20px;
    }

    .buyItem span {
        margin-left: 4px;
    }

    .acName {
        font-weight: 600;
        font-size: 18px;
    }

    .acInfo {
        flex: 1;
    }

    .acImg {
        width: 344px;
        height: 194px;
        margin-right: 20px;
        flex-shrink: 0;
    }

    .acImg img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        object-fit: cover;
    }

    .acTivitiesDetail {
        width: 100%;
        background: #fff;
        box-sizing: border-box;
        padding: 26px;
    }

    .cons {
        width: 1460px;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 0;
        border-radius: 10px;
    }
</style>